const dictionary = {
  no: {
    PLAYER_START_SPEED_COURSE: 'Start Speed Quiz',
    ANSWER_CORRECT: 'Correct',
    ANSWER_WRONG: 'Wrong',
    SPEED_COURSE: 'Speed Course',
    COURSE_RESULT_FAIL: 'Prøv igjen',
    COURSE_RESULT_SCORE: 'Din Rangering',
    POINTS: 'poeng',
    OF: 'av',
    PLAYER_HINT_ORDER: 'Trykk på svaralternativene i riktig rekkefølge fra 1 til ',
    PLAYER_NEXT: 'Neste',
    PLAYER_PREV: 'Tilbake',
    PLAYER_EXIT: 'Avslutt',
    PLAYER_CLOSE_BROWSER: 'Kurset er avsluttet du kan lukke vindu',
    PLAYER_CLOSE_COURSE: 'Lukk kurs',
    PLAYER_SUBMIT_QUIZ_ANSWER: 'Svar',
    PLAYER_FLIP_DILEMMA_CARD: 'Flipp kort',
    ERROR_OCCURED: 'Det oppstod en feil',
    PLAYER_QUIZ_ANSWER_COMMENT_CORRECT: 'Riktig',
    PLAYER_QUIZ_ANSWER_COMMENT_WRONG: 'Ikke riktig',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_CORRECT: 'Bra jobbet!',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_WRONG: 'Dessverre feil.',
    PLAYER_CONTINUE: 'Fortsett',
    PLAYER_RETRY: 'Prøv igjen',
    PAGE_LOADING_RESOURSES: 'Laster [x] av [y] resurser',
    PAGE_LOADING_IMAGE: 'resurser',
    PAGE_LOADING: 'Laster...',
  },
  en: {
    PLAYER_START_SPEED_COURSE: 'Start Speed Quiz',
    ANSWER_CORRECT: 'Correct',
    ANSWER_WRONG: 'Wrong',
    SPEED_COURSE: 'Speed Course',
    COURSE_RESULT_FAIL: 'Try again',
    COURSE_RESULT_SCORE: 'Your score',
    POINTS: 'points',
    OF: 'of',
    PLAYER_HINT_ORDER: 'Click the alternatives in correct order from 1 to ',
    PLAYER_NEXT: 'Next',
    PLAYER_PREV: 'Back',
    PLAYER_EXIT: 'Exit',
    PLAYER_CLOSE_BROWSER: 'The course is finished, you can now close the window',
    PLAYER_CLOSE_COURSE: 'Close course',
    PLAYER_SUBMIT_QUIZ_ANSWER: 'Submit',
    PLAYER_FLIP_DILEMMA_CARD: 'Flip card',
    ERROR_OCCURED: 'An error occurred',
    PLAYER_QUIZ_ANSWER_COMMENT_CORRECT: 'Correct',
    PLAYER_QUIZ_ANSWER_COMMENT_WRONG: 'Incorrect',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_CORRECT: 'Good job!',
    PLAYER_QUIZ_ANSWER_DEFAULT_COMMENT_WRONG: 'That wasn\'t the right answer.',
    PLAYER_CONTINUE: 'Continue',
    PLAYER_RETRY: 'Try again',
    PAGE_LOADING_RESOURSES: 'Loading [x] of [y] resources',
    PAGE_LOADING_IMAGE: 'resources',
    PAGE_LOADING: 'Loading ...',
  },
};

export const setDictionary = newDictionary => {
  const lang = localStorage.getItem('language') || 'no';

  Object.assign(dictionary[lang], newDictionary);
  dictionary['PLAYER_START_SPEED_COURSE'] = 'Kjør på!';
};

export const getDictionary = () => {
  const lang = localStorage.getItem('language') || 'no';

  return dictionary[lang];
};
